import {
  generateInitialValues,
  generateQuestionnairePayload,
  generateValidationSchema,
  paginateQuestionnaires,
} from '../utils';
import {FormikValues, useFormik} from 'formik';
import {
  Question,
  Questionnaires,
  QuestionnaireType,
} from '~/services/api/MedicalHistory/Questionnaire/types';
import DailyLivingAndHospitalExperienceComponent from './component';

interface DailyLivingAndHospitalExperienceFormProps {
  itemsPerPage: number;
  currentPage: number;
  questionnaire: Question[];
  handlePageChange: (page: number) => void;
  submitPatientQuestionnaire: (payload: Questionnaires[]) => void;
  handleBack: () => void;
  disableSubmit: boolean;
  isCreatingPatientQuestionnaire: boolean;
  questionnaireType: QuestionnaireType;
  patientName?: string;
}

const DailyLivingAndHospitalExperienceForm = (
  props: DailyLivingAndHospitalExperienceFormProps
) => {
  const {
    currentPage,
    itemsPerPage,
    questionnaire,
    handlePageChange,
    submitPatientQuestionnaire,
    disableSubmit,
    handleBack,
    isCreatingPatientQuestionnaire,
    questionnaireType,
    patientName,
  } = props;

  const {questionsToDisplay, startIndex, totalPages} = paginateQuestionnaires(
    questionnaire,
    currentPage,
    itemsPerPage
  );

  const initialValues = generateInitialValues(questionnaire);
  const validationSchema = generateValidationSchema(questionsToDisplay);

  const handleSubmitQuestionnaire = (values: FormikValues) => {
    const payload = generateQuestionnairePayload(values);
    submitPatientQuestionnaire(payload);
  };

  const handleFormSubmit = async () => {
    const errors = await formik.validateForm();
    const isFormValid = Object.keys(errors).length === 0;
    const isLastPage = currentPage === totalPages;

    if (isFormValid) {
      if (isLastPage) {
        formik.handleSubmit();
      } else {
        handlePageChange(currentPage + 1);
      }
    }
  };

  const formik = useFormik<FormikValues>({
    initialValues,
    validationSchema,
    onSubmit: values => {
      handleSubmitQuestionnaire(values);
    },
  });

  return (
    <DailyLivingAndHospitalExperienceComponent
      currentPage={currentPage}
      handleBack={handleBack}
      handlePageChange={handlePageChange}
      startIndex={startIndex}
      totalPages={totalPages}
      questionsToDisplay={questionsToDisplay}
      formik={formik}
      handleFormSubmit={handleFormSubmit}
      disableSubmit={disableSubmit || isCreatingPatientQuestionnaire}
      questionnaireType={questionnaireType}
      patientName={patientName}
    />
  );
};

export default DailyLivingAndHospitalExperienceForm;
